import * as React from "react"
const Front = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width={"100%"}
    height={"100%"}
    x={0}
    y={0}
    viewBox="47.164 6.58 33.93 50.465"
    {...props}
  >
    <style>
      {
        `.st0{fill:none;stroke:${props.color};stroke-width:.6;stroke-linecap:round;stroke-linejoin:round}`
      }
    </style>
    <g id="Layer_2_00000053544620536537183360000011948662383891169943_">
      <path
        d="M63.9 56.8H63c-1.3 0-2.3-1.2-2.3-2.6V34.7H66v19.8c0 1.2-.9 2.3-2.1 2.3zM67.1 34.6h-7.3v-1.1c0-1.6 1.3-3 3-3H64c1.6 0 3 1.3 3 3v1.1h.1zM59.7 34.6l.1 8.3M67.1 34.7v8.2M60.5 43.9h-.9l-.5-.4v-1"
        className="st0"
      />
      <path
        d="M60.5 44.5h-.8l-.1.7h-1.4v-.4h-.4v-.7l.1-.3v-2.1M59.8 42.9h-.4l-1.9-1.7-.9-1-1-.4-1.9-2.9v-3.8l-.7-2-.4-5 .5-2.8.2-4 1.9-2.4.2-2.3M73.6 12.7c.3 1.1 2.2 1.5 3.9 1 1.7-.5 3-1.8 2.7-2.9s-2.4-1.5-4.2-.9c-1.6.4-2.8 1.7-2.4 2.8z"
        className="st0"
      />
      <path
        d="m74.1 13.4-3 2.6-.1.5-.4.3h-.4l-.3-.3V16c0-.2 0-.4.1-.6l.4-.9 1.4-.5 1.8-1.3M54.3 12.4c-.3 1.1-2.2 1.5-3.9 1-1.7-.4-3-1.8-2.7-2.9s2.4-1.4 4.1-.9c1.7.6 2.8 1.9 2.5 2.8z"
        className="st0"
      />
      <path
        d="m53.9 13.3 3 2.6v.4l.5.3h.3l.2-.1c.1-.2.2-.4.2-.8v-.2c0-.1 0-.2-.1-.4l-.4-.8-1.4-.5-1.8-1.3M61.3 26.2l-4.4-.9c-1-.1-1.6-.9-1.8-1.8l-.5-3.2c0-.3.2-.5.5-.4l4 1.6c1.2.5 2.1 1.5 2.5 2.7l.3 1.2c.1.5-.3.8-.6.8zM66.3 26.2l4.4-.8c1-.1 1.6-.9 1.8-1.8l.5-3.2c0-.3-.2-.5-.5-.4l-3.9 1.6c-1.2.5-2.1 1.5-2.5 2.7l-.3 1.2c-.3.5.1.8.5.7zM67.8 42.8v.8l-.5.5h-.8"
        className="st0"
      />
      <path d="M66.5 44.6h.8v.8h1.4v-.5h.4v-.8l-.1-.2v-2.3" className="st0" />
      <path
        d="m72 15.4 1.8 3.8.3 1.2.1 2.6-.1 1.2.1 1.3-.2 1-.2 2.9-.1 1.5-.6 2.4v2.9c-.1 2.1-1 3.5-2.7 3.9l-2.7 2.6-.3.2h-.3v-.3M71.5 13.9l.2-.5-.5-1.1-3.8-4.1c-.1-.2-.4-.3-.6-.3l-5.3-.2c-.4 0-1 .1-1.3.5L56.7 12l-.9 1.3"
        className="st0"
      />
      <circle cx={69.8} cy={22.5} r={1.2} className="st0" />
      <circle cx={58.2} cy={22.6} r={1.2} className="st0" />
    </g>
  </svg>
)
export default Front
